import { useState } from "react";
import Button from "../../../components/Button/Button";
import { MdApartment } from "react-icons/md";
import Select from "../../../components/Select/Select";
import ModalComponent from "../../../components/Modal/ModalComponent";
import ListUnits from "../../Units/ListUnits/ListUnits";
import { useListManager } from "../../../contexts/list.manager";
import { useUserStore } from "../../../contexts/userStore";
import Input from "../../../components/Input/Input";
import { useFastCondoUserStore } from "./context";
import { DynamicIcon } from "../../../components/DynamicIcon/DynamicIcon";
import { BiCollapseAlt } from "react-icons/bi";
import { UnitResponsibility, UnitResponsibilityText, UnitResponsibleRelation, UnitResponsibleRelationText } from "../../../constants/unit";
import { useTranslation } from "react-i18next";

export function UnitStep() {
   const { t } = useTranslation();
   const { selectedCondominioObj } = useUserStore();
   const [modalIsOpen, setModalIsOpen] = useState(false);
   const [customInput1, setCustomInput1] = useState("");
   const { lineSelected, setLineSelected, closeForm } = useListManager();
   const [filters, setFilters] = useState([""]);
   const {
      unit,
      relation,
      otherRelation,
      responsibility,
      selectedTag,
      isSubmitting,
      parseUnitData,
      update
   } = useFastCondoUserStore();

   async function saveCondoUserUnit() {
      if (!lineSelected) return;

      const payload = parseUnitData(lineSelected);
      update("unit", payload);
   }

   async function handleConfirm() {
      saveCondoUserUnit();
      setModalIsOpen(false);
   }

   async function handleCancel() {
      setModalIsOpen(false);
   }

   function handleUnlinkUnit() {
      update("unit", null);
   }

   const unitTag = unit?.tags?.find(t => t.linkableToUser && t.sendToDevices);

   return (
      <>
         <div className="w-[90%]! mx-auto! mt-1!">
            <div className="w-full! flex flex-col justify-between items-center mb-2! text-(--textColor)">
               <label htmlFor="select-unit-button" className="block w-full text-sm! text-left text-(--textColor) mb-1!">
                  {t('common.unit')}
               </label>
               <div className={`relative w-full flex flex-col gap-2 border! border-(--borderColor)! rounded-lg p-3.5! box-border!`}>
                  <div className="flex flex-row items-center gap-5">
                     <button
                        type="button"
                        onClick={() => setModalIsOpen(true)}
                        className="w-full flex flex-row items-center justify-between gap-3 rounded-lg"
                     >
                        {!unit ? (
                           <>
                              <div className="flex flex-row items-center gap-3">
                                 <div className="size-[50px] rounded-full border-2! border-(--primaryColor)! border-dashed!"></div>
                                 <h3 className="text-sm! opacity-60">{t("monitoring.noUnitSelected")}</h3>
                              </div>
                           </>
                        ) : (
                           <>
                              <div className="flex flex-row items-center gap-3" style={{ '--tagColor': unitTag?.color }}>
                                 <div className="relative flex items-center justify-center size-[54px] rounded-full">
                                    <span className="absolute size-full opacity-15 bg-(--tagColor) rounded-full z-10"></span>
                                    <DynamicIcon iconName={unitTag?.icon} size={30} color={unitTag?.color} className="relative z-20" />
                                 </div>
                                 <div className="flex flex-col justify-center gap-2! flex-1">
                                    <h3 className="font-bold text-left w-full text-[15px]!">
                                       <span className="opacity-80">{unitTag?.name}:</span>
                                       {' '}
                                       {unit.name}
                                    </h3>
                                    <div className="flex flex-row items-center">
                                       <span className="text-xs! opacity-80 mr-3.5!">
                                          <strong className="opacity-65">Nº de Vagas:</strong> {unit.parkingLotQuantity}
                                       </span>
                                       <span className="text-xs! opacity-80">
                                          <strong className="opacity-65">Vagas Ocupadas:</strong>{" "}
                                          {unit.parkingLotBusy}
                                       </span>
                                    </div>
                                 </div>
                              </div>
                           </>
                        )}
                        <BiCollapseAlt />
                     </button>
                     {unit && (
                        <Button
                           className="button-red"
                           label={t("common.remove")}
                           onClick={handleUnlinkUnit}
                        />
                     )}
                  </div>
                  {unit && (
                     <div className={`grid grid-cols-2 gap-4 w-full mt-3! mb-2.5! px-1.5! box-border!`}>
                        <Select
                           labelText={t("monitoring.responsibilityIn", { name: unit.name })}
                           value={`${responsibility}`}
                           onChange={({ target }) => {
                              update("responsibility", target.value)
                           }}
                           required={false}
                           options={Object.entries(UnitResponsibilityText).map(([key, value]) => ({
                              value: key,
                              text: t(value),
                           }))}
                           disabled={isSubmitting}
                        />
                        {responsibility !== `${UnitResponsibility.RESPONSIBLE}` && (
                           <div className="w-full">
                              <Select
                                 labelText={t("monitoring.relationWithResponsible")}
                                 value={relation}
                                 onChange={({ target }) => {
                                    update("relation", target.value)
                                 }}
                                 required={false}
                                 options={Object.entries(UnitResponsibleRelationText).map(([key, value]) => ({
                                    value: key,
                                    text: t(value),
                                 }))}
                                 disabled={isSubmitting}
                              />
                           </div>
                        )}
                        {relation === `${UnitResponsibleRelation.OTHER}` && (
                           <div className="w-full">
                              <Input
                                 labelText={t("monitoring.otherRelationWithResponsibleQuestion")}
                                 value={otherRelation}
                                 onChange={({ target }) => {
                                    update("otherRelation", target.value)
                                 }}
                                 required={true}
                                 type="text"
                                 disabled={isSubmitting}
                              />
                           </div>
                        )}
                     </div>
                  )}
               </div>
            </div>
         </div>
         <ModalComponent
            modalIsOpen={modalIsOpen}
            modalText={t("monitoring.selectUnit")}
            handleConfirm={handleConfirm}
            handleCancel={handleCancel}
         >
            <div className="tab-units-search-container">
               <Input
                  value={customInput1}
                  type="text"
                  placeholder={t("common.search")}
                  onChange={({ target }) => setCustomInput1(target.value)}
                  onKeyPress={(e) => e.key === "Enter" && setFilters([customInput1])}
                  className="search-input input-form"
               />
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
               <div style={{ width: "420px", height: "fit-content" }}>
                  <ListUnits
                     showSelectedIcon={true}
                     showTags={true}
                     // scopeTags={[selectedTag]}
                     filters={filters}
                     linkableToUser={true}
                     smallList={true}
                     unitId={selectedCondominioObj?.id}
                  />
               </div>
            </div>
         </ModalComponent>
      </>
   );
}